import layoutEngine from 'layoutEngine'

if (layoutEngine.vendor === 'ie' && layoutEngine.version <= 10) {
  require('./utils/sharePlayerFullscreen')
}



// WEBPACK FOOTER //
// ../src/ie-entry.js